import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Page d'accès refusé
 * Affichée quand l'utilisateur n'a pas les permissions nécessaires
 */
const AccessDenied = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      textAlign: 'center',
      padding: '40px 20px'
    }}>
      <div style={{
        fontSize: '80px',
        marginBottom: '20px'
      }}>
        🚫
      </div>
      <h1 style={{
        fontSize: '28px',
        fontWeight: '600',
        color: '#1a1a2e',
        marginBottom: '12px'
      }}>
        Accès refusé
      </h1>
      <p style={{
        fontSize: '16px',
        color: '#64748b',
        marginBottom: '32px',
        maxWidth: '400px'
      }}>
        Vous n'avez pas les permissions nécessaires pour accéder à cette page.
        Contactez votre administrateur si vous pensez qu'il s'agit d'une erreur.
      </p>
      <Link
        to="/dashboard"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          padding: '12px 24px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          textDecoration: 'none',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: '500',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 4px 12px rgba(102, 126, 234, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = 'none';
        }}
      >
        ← Retour au tableau de bord
      </Link>
    </div>
  );
};

export default AccessDenied;
